import React from 'react';
import {
  FaHeadset,
  FaCalendarAlt,
  FaFolderOpen,
  FaSearch,
  FaNewspaper,
  FaBook,
  FaDollarSign,
  FaKey,
  FaClipboardList,
} from 'react-icons/fa';
import { RiUserSettingsLine, RiListSettingsLine } from 'react-icons/ri';
import { IoIosPaper } from 'react-icons/io';
import trabalhos from '~/Images/trabalhos.svg';
import workflow from '~/Images/workflow.svg';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constants';

const links = [
  {
    icon: <img src={trabalhos} alt="Negócios" />,
    label: 'Negócios',
    dropdown: [
      {
        href: '/negocios/caixa-aprovacao',
        icon: <img src={workflow} alt="Caixa de Aprovação" />,
        label: 'Caixa de Aprovação',
      },
      {
        href: '/transmissao-documentos',
        icon: <FaFolderOpen />,
        label: 'Solicitação Despesa/Projeto',
        visible: () =>
          AuthStorage.temCaracteristica(
            caracteristicas.PodeSolicitarDespesaProjeto
          ),
      },
      {
        href: '/consultar-solicitacoes',
        icon: <FaSearch />,
        label: 'Consulta Solicitação',
        visible: () =>
          AuthStorage.temCaracteristica(
            caracteristicas.PodeSolicitarDespesaProjeto
          ),
      },
      {
        href: '/mapa',
        icon: <FaNewspaper />,
        label: 'Mapa Salas',
      },
    ],
  },
  {
    icon: <FaHeadset />,
    label: 'Atendimento',
    isNew: true,
    visible: () =>
      AuthStorage.temCaracteristicas([
        caracteristicas.ConfiguraAtendimento,
        caracteristicas.RealizaAgendamento,
      ]),
    dropdown: [
      {
        href: '/atendimento/agendamento',
        icon: <FaCalendarAlt />,
        label: 'Agendamento',
        visible: () =>
          AuthStorage.temCaracteristica(caracteristicas.RealizaAgendamento),
      },
      {
        href: '/atendimento/configuracao/atendentes',
        icon: <RiUserSettingsLine />,
        label: 'Configuração de Atendentes',
        visible: () =>
          AuthStorage.temCaracteristica(caracteristicas.ConfiguraAtendimento),
      },
      {
        href: '/atendimento/configuracao/servicos',
        icon: <RiListSettingsLine />,
        label: 'Configuração de Servicos',
        visible: () =>
          AuthStorage.temCaracteristica(caracteristicas.ConfiguraAtendimento),
      },
      {
        href: '/atendimento/agendamento/relatorio',
        icon: <IoIosPaper />,
        label: 'Relatório de Agendamentos',
        visible: () =>
          AuthStorage.temCaracteristicas([
            caracteristicas.ConfiguraAtendimento,
            caracteristicas.RealizaAgendamento,
          ]),
      },
    ],
  },
  {
    icon: <FaBook />,
    label: 'Relatórios',
    isNew: true,
    visible: () => {
      return true;
    },
    dropdown: [
      {
        href: '/relatorio/comissoes',
        icon: <FaDollarSign />,
        label: 'Relatório de Comissões',
      },
      {
        href: '/relatorio/chaves',
        icon: <FaKey />,
        label: 'Relatório de Chaves',
        visible: () =>
          AuthStorage.temCaracteristica(
            caracteristicas.VisualizaRelatorioChaves
          ),
      },
      {
        href: '/relatorio/solicitacoes',
        icon: <FaClipboardList />,
        label: 'Relatório de Solicitações',
        visible: () =>
          AuthStorage.temCaracteristica(
            caracteristicas.VisualizaRelatorioSolicitacoes
          ),
      },
    ],
  },
];

const getLinks = () =>
  links
    .map(link => {
      if (!link.dropdown) return link;

      return {
        ...link,
        dropdown: link.dropdown.filter(
          drop => !drop.visible || (drop.visible && drop.visible())
        ),
      };
    })
    .filter(link => !link.visible || (link.visible && link.visible()));

export default getLinks;
